var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{ref:"dropzone",staticClass:"dropzone"},[_vm._t("dropzone-container",function(){return [_vm._t("dropzone-message",function(){return [_vm._v("Drop files here to upload")]})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }